import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[sousAd]'
})
export class AdDirective {

  constructor(public viewContainerRef: ViewContainerRef) {
  }

}
